import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { Fragment, memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import {
  Annotations,
  DataWizardAct,
  LastStepVM,
  ParentVM,
  SectionVM,
} from 'civil-status/view-models/step-form';
import { initialValuesSections } from 'civil-status/constants/initial-values-step';
import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import ActConsent from './act-consent';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import DeadData from './dead-data';
import CitizenshipBase from './citizenship-base';
import CitizenshipCit from './citizenship-cit';
import RecognitionBeforBirth from './recognition-befor-birth';
// import RecognitionBeforBirthAct from './recognition-befor-birth-act';
import { touchedSection } from 'civil-status/constants/touched-section-subject';
import { CodeSection } from 'civil-status/constants/code-subject-section';
import { CodeSectionEventoRiconoscimento } from 'civil-status/constants/code-section-evento-riconoscimento';
import TranscriptionForeign from './transcription-foreign';
import Authority from './authority';
import TranscriptionData from './transcription-data';
import RecognitionBeforBirthAct from './recognition-befor-birth-act';
import CitizenshipDpImp from './citizenship-dp-imp';
import ActRelated from './act-related';
import ActComposition from './act-composition';
import GeneralData from './general-data';
import GeneralDataRecognition from './general-data-recognition';
import { clearSection, clearSectionMomentary } from 'civil-status/utils/clear-section';
import GeneralDataLackConsent from './general-data-lack-consent';
import ParentTransmittedCitizenship from './parent-transmitted-citizenship';
import { KeySections } from 'civil-status/constants/keys-subjects-section';
import { isObjectEmpty } from 'shell/utils/is-object-empty';
import { typePresence } from 'civil-status/constants/type-presence';
import { ItemVM } from 'shell/view-models/item';
import ParentRecognition from './parent-recognition';
import ResultVerificationMayor from './result-verification-mayor';
import GeneralDataOath from './general-data-oath';
import LastPlace from './last-place';
import GeneralDataBorn from './general-data-born';
import AnnotationsData from './annotations-data';
import SpecificDataCivilUnionMarriage from './specific-data-civil-union-marriage';
import IncorporationCertificate from './incorporation-certificate';
import PropertyRegime from './property-regime';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { ValoreDominioVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { Tooltip } from '@mui/material';
import ComsciousData from './comscious-data';
import PubbliData from './pubbli-data';
import SeparationData from './separation-data';
import BaseCivilUnionData from './base-civil-union-data';
import NegotiationData from './negotiation-data';
import SupplementaryData from './supplementary-data';
import ReconciliationData from './reconciliation-data';
import AssentSonData from './assent-son-data';
import MarriageData from './marriage-data';
import {
  keyIdConsenso,
  keyIdDatiEventoRiconoscimento,
  keyRiconoscimentoList,
} from 'civil-status/constants/update-id-step';
import PublicationData from './publication';
import { IdPropertyRegime } from 'civil-status/constants/id-property-regime';
import ReceivedByPost from './recived-by-post';
import RefCitizenship from './ref-citizenship';
import SonUnknownParents from './son-unknown-parents';
import GeneralDataGannmo from './general-data-gannmo';
import AssentSonDataNew from './assent-son-data/assent-son-data-new';

interface SectionProps {
  formContext: FormikProps<LastStepVM>;
  onSaveSection: (values: SectionVM) => ResponsePromise<DataWizardAct> | void | undefined;
  title?: string;
  keySection: string;
  codSection: string;
  configuration?: string;
  presenza?: string;
  tipoEvento?: string;
  idUseCase?: string;
  idEvento?: number;
  dateFormationAct?: string;
  disabled?: boolean;
  isLastStepEmergency?: boolean;
  setDataInterprete: (isWithInterprete?: boolean) => void;
  controllSentenceRecognition: (sentenceRecognition?: string) => void;
  controllSentenceRecognitionNameSurname: (sentenceRecognition?: string) => void;
  controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence: (
    typologyConsentAndConfiguration?: ItemVM,
    typeDeclaration?: string,
    parentRecognition?: string,
    isIncestuousSonSentence?: boolean
  ) => void;
  controllIsPaternitySentence: (isPaternitySentence?: boolean) => void;
  controllParentTransmittedCitizenship: (parentTransmittedCitizenship?: string) => void;
  controllParentRecognitionMadrePadreRiconoscimento: (parentRecognition?: string) => void;
  controllParentChangedSurname: (parentChangedSurname?: string) => void;
  controllApplicant: (applicant?: string) => void;
  controllMeasureExchangeSurname: (measureExchangeSurname?: string) => void;
  controllOpposition: (opposition?: string) => void;
  controllGenericImpediment: (genericImpediment?: string) => void;
  controllImpedimentUnitedCivilly: (impedimentUnitedCivilly?: string) => void;
  controllPublication: (publication?: string) => void;
  controllMinorGroomAssistance: (minorGroomAssistance?: string) => void;
  controllMinorWifeAssistance: (minorWifeAssistance?: string) => void;
  controllAgeDefect: (ageDefect?: string) => void;
  controllTemporaryBanRemarriage: (isTemporaryBanRemarriage?: boolean) => void;
  controllRelationship: (relationship?: string) => void;
  controllNumberWitnesses: (numberWitnesses?: string) => void;
  controllPropertyRegime: (propertyRegime?: string) => void;
  controllLawyerHusbandWife: (isLawyerHusband?: boolean, isLawyerWife?: boolean) => void;
  controllTypeSeparation: (typeSeparation?: string) => void;
  controllIsLawyerHusbandWife: (isLawyerHusbandWife?: boolean) => void;
  controllIsReceivedPrivateCitizen: (isReceivedPrivateCitizen?: boolean) => void;
  controllIsSonUnderFourteen: (isSonUnderFourteen?: boolean) => void;
  controllIsReceivedByPost: (isReceivedByPost?: boolean) => void;
  controllTypeApplicant: (typeApplicant?: string) => void;
  controllNumberHolders: (numberHolders?: string) => void;
  controllNumberChildren: (numberChildren?: string) => void;
}

const SectionComponent = ({
  formContext,
  onSaveSection,
  controllSentenceRecognition,
  controllSentenceRecognitionNameSurname,
  controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence,
  setDataInterprete,
  controllIsPaternitySentence,
  controllParentTransmittedCitizenship,
  controllParentRecognitionMadrePadreRiconoscimento,
  controllParentChangedSurname,
  controllApplicant,
  controllMeasureExchangeSurname,
  controllOpposition,
  controllGenericImpediment,
  controllImpedimentUnitedCivilly,
  controllPublication,
  controllMinorGroomAssistance,
  controllMinorWifeAssistance,
  controllAgeDefect,
  controllTemporaryBanRemarriage,
  controllRelationship,
  controllNumberWitnesses,
  controllPropertyRegime,
  controllLawyerHusbandWife,
  controllTypeSeparation,
  controllIsLawyerHusbandWife,
  controllIsReceivedPrivateCitizen,
  controllIsSonUnderFourteen,
  controllIsReceivedByPost,
  controllTypeApplicant,
  controllNumberHolders,
  controllNumberChildren,
  title = '',
  keySection = '',
  codSection = '',
  configuration = '', // tipo di configurazione dei dati
  presenza = '',
  tipoEvento = '',
  idUseCase = '',
  dateFormationAct = '',
  idEvento,
  disabled = false,
  isLastStepEmergency = false,
}: SectionProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const values = (formContext.values[keySection] || {}) as SectionVM;

  const onChange = useEventCallback((key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => {
    formContext.setFieldValue(keySection, {
      ...(values || {}),
      [key]: value,
    });
  });

  const onChanges = useEventCallback((valuesNew: SectionVM) => {
    formContext.setFieldValue(keySection, {
      ...(values || {}),
      ...(valuesNew || {}),
    });
  });

  // const onFieldsChanges = useEventCallback((valuesNew: SectionVM) => {
  //   formContext.setFieldValue(keySection, valuesNew);
  // });

  const onClean = useEventCallback(() => {
    formContext.setValues({
      ...formContext.values,
      [keySection]: {
        ...initialValuesSections,
        ...clearSection(values),
        isRequiredFromOtherAccordion:
          (formContext.values[keySection] as SectionVM)?.isRequiredFromOtherAccordion || false,
      } as SectionVM,
    });
  });

  const errors: FormikErrors<SectionVM> | undefined = useMemo(() => {
    return (formContext.errors[keySection] as unknown as FormikErrors<SectionVM>) || undefined;
  }, [formContext.errors]);

  const withErrors: boolean = useMemo(() => {
    if (errors && Object.keys(errors)?.length > 0) {
      return true;
    }

    return false;
  }, [errors]);

  const onDelete = useEventCallback(() => {
    // TODO servizio che elimina sul DB

    // if (!values?.generality?.idSubject) {
    //   // se l'idSoggetto non è presente non effettuare pulizia sul DB perchè il soggetto non è stato salvato
    //   onClean();
    //   return;
    // }

    // (deleteData() as unknown as ResponsePromise<void>).then(() => {
    //   toast.success('Operazione eseguita con successo');

    onClean();

    //});
  });

  const onSave = useEventCallback(() => {
    const touched = {
      [keySection]: {
        ...touchedSection,
      } as unknown as FormikTouched<SectionVM>,
    } as unknown as FormikTouched<LastStepVM>;

    formContext.setTouched(touched);

    if (withErrors) {
      // se è presente errore non effettuare chiamata e segnalarli con il setTouched
      return;
    }

    // La sezione "Atto assenso figlio" scrive dentro datiEventoRiconoscimento, oggetto condiviso
    // con la sezione dati generali. Salvando solo questa sezione il transformer
    // ricostruirebbe l'oggetto da zero azzerando gli altri campi. Per questo invio la sezione dati
    // generali riconoscimento (con tutti i dati già presenti nel form) arricchita con consentReturnedBefore.
    let valuesToSave = values;

    if (codSection === CodeSection.ATTO_ASSENSO_FIGLIO_RESO) {
      const generalRecognitionSection = Object.values(formContext.values).find((item) =>
        CodeSectionEventoRiconoscimento.includes((item as SectionVM)?.codeSection as CodeSection)
      ) as SectionVM | undefined;

      if (generalRecognitionSection) {
        valuesToSave = {
          ...generalRecognitionSection,
          consentReturnedBefore: values.consentReturnedBefore,
        };
      }
    }

    onSaveSection(valuesToSave)?.then((res) => {
      // TODO ottimizzare in values abbiamo il codice sezione corrente quindi utilizzare direttamente lui
      const dataSaved = (res || undefined) as DataWizardAct | undefined;

      const keySectionForm = Object.keys(formContext.values)?.filter((item) =>
        item.includes('section')
      );

      let newValues = { ...formContext.values };

      keySectionForm.forEach((itemKeyCurrentForm) => {
        // Codice sezione corrente
        const itemKeyCurrent =
          ((formContext.values[itemKeyCurrentForm] || {}) as SectionVM).codeSection || '';

        const castedStatoCivile = dataSaved?.statoCivile || {};
        const castedEvento = dataSaved?.evento || {};
        const castedImpedimentoList = dataSaved?.impedimentoList || [];
        const castedRegimePatrimoniale = dataSaved?.regimePatrimoniale || {};
        const castedPubblicazioneList = dataSaved?.pubblicazioneList || [];
        const currentEnteDichiarante = dataSaved?.enteDichiaranteList?.find(
          (item) => item.sezione?.trim() === itemKeyCurrent
        );
        const currentEnteDichiaranteCodSezione = currentEnteDichiarante?.sezione?.trim() || '';
        const currentIdAttoCollegato =
          dataSaved?.attoCollegatoList?.find((item) => item.sezione?.trim() === itemKeyCurrent)?.key
            ?.idAttoCollegato || undefined;

        // Verifica se la sezione corrente è quella dei Dati Generali di Riconoscimento
        const isCurrentDatiGeneraliRiconoscimento =
          itemKeyCurrent === CodeSection.DATI_GENERALI_RICONOSCIMENTO;
        // Verifica se la sezione corrente è quella dell'Autorizzazione di Riconoscimento
        const isCurrentAutorizzioneRiconoscimento =
          itemKeyCurrent === CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE;
        const isCurrentUltimoLuogo =
          itemKeyCurrent === CodeSection.ULTIMO_LUOGO ||
          itemKeyCurrent === CodeSection.DATI_SPECIFICI_UNICIV;
        const isCurrentCertUnioneCivile =
          itemKeyCurrent === CodeSection.CERT_RIC_UNICIV_1 ||
          itemKeyCurrent === CodeSection.CERT_RIC_UNICIV_2;
        const isCurrentRegimePatrimoniale = itemKeyCurrent === CodeSection.REGIME_PATRIMONIALE;
        const isCurrentPubblicazione1 = itemKeyCurrent === CodeSection.PUBBLICAZIONE_1;
        const isCurrentPubblicazione2 = itemKeyCurrent === CodeSection.PUBBLICAZIONE_2;
        const isCurrentDatiregistroEmergenza =
          itemKeyCurrent === CodeSection.DATI_REGISTRO_EMERGENZA;

        // Costruzione dei nuovi valori per la sezione dei Dati Generali di Riconoscimento, se necessario
        const newValuesToDatiGeneraliRiconoscimento = isCurrentDatiGeneraliRiconoscimento
          ? {
              [KeySections.keyDatiGeneraliRiconoscimento]: {
                ...(formContext.values[KeySections.keyDatiGeneraliRiconoscimento] || {}),
                // Aggiornamento dell'id del certificato sanitario se necessario
                idCertSanitario:
                  isCurrentDatiGeneraliRiconoscimento || isCurrentAutorizzioneRiconoscimento
                    ? dataSaved?.certificatoSanitario?.key?.idCertSanitario || undefined
                    : undefined,
                // Aggiornamento dell'id dell'ente dichiarante se necessario
                idEnteDichiarante:
                  currentEnteDichiarante?.key?.idEnteDichiarante ||
                  (formContext.values[KeySections.keyDatiGeneraliRiconoscimento] as SectionVM)
                    ?.idEnteDichiarante,
                idCertificato:
                  castedImpedimentoList.find(
                    (itemImpedimento) =>
                      itemImpedimento.sezione === currentEnteDichiaranteCodSezione
                  )?.idCertificato || undefined,
                idImpedimento:
                  castedImpedimentoList.find(
                    (itemImpedimento) =>
                      itemImpedimento.sezione === currentEnteDichiaranteCodSezione
                  )?.key?.idImpedimento || undefined,
                // Impostazione dello stato isSaved su true
                isSaved: true,
              },
            }
          : {};

        // Costruzione dei nuovi valori per la sezione dell'Autorizzazione di Riconoscimento, se necessario
        const newValuesToAutorizzioneRiconoscimento = isCurrentAutorizzioneRiconoscimento
          ? {
              [KeySections.keyAutorizzazioneRiconoscimentoPadre]: {
                ...(formContext.values[KeySections.keyAutorizzazioneRiconoscimentoPadre] || {}),
                // Aggiornamento dell'id del certificato sanitario se necessario
                idCertSanitario:
                  isCurrentDatiGeneraliRiconoscimento || isCurrentAutorizzioneRiconoscimento
                    ? dataSaved?.certificatoSanitario?.key?.idCertSanitario || undefined
                    : undefined,
                // Aggiornamento dell'id dell'ente dichiarante se necessario
                idEnteDichiarante:
                  currentEnteDichiarante?.key?.idEnteDichiarante ||
                  (
                    formContext.values[
                      KeySections.keyAutorizzazioneRiconoscimentoPadre
                    ] as SectionVM
                  )?.idEnteDichiarante,
                idCertificato:
                  castedImpedimentoList.find(
                    (itemImpedimento) =>
                      itemImpedimento.sezione === currentEnteDichiaranteCodSezione
                  )?.idCertificato || undefined,
                idImpedimento:
                  castedImpedimentoList.find(
                    (itemImpedimento) =>
                      itemImpedimento.sezione === currentEnteDichiaranteCodSezione
                  )?.key?.idImpedimento || undefined,
                // Impostazione dello stato isSaved su true
                isSaved: true,
              },
            }
          : {};

        // Costruzione dei nuovi valori per le sezioni diverse dai Dati Generali e dall'Autorizzazione di Riconoscimento
        const newValuesCurrent =
          !isCurrentDatiGeneraliRiconoscimento && !isCurrentAutorizzioneRiconoscimento
            ? {
                [itemKeyCurrentForm]: {
                  ...formContext.values[itemKeyCurrentForm],
                  // Aggiornamento dell'id del certificato sanitario se necessario
                  idCertSanitario:
                    isCurrentDatiGeneraliRiconoscimento || isCurrentAutorizzioneRiconoscimento
                      ? dataSaved?.certificatoSanitario?.key?.idCertSanitario || undefined
                      : undefined,
                  // Aggiornamento dell'id dell'ente dichiarante se necessario
                  idEnteDichiarante:
                    currentEnteDichiarante?.key?.idEnteDichiarante ||
                    (formContext.values[itemKeyCurrentForm] as SectionVM)?.idEnteDichiarante,
                  idCertificato:
                    castedImpedimentoList.find(
                      (itemImpedimento) =>
                        itemImpedimento.sezione === currentEnteDichiaranteCodSezione
                    )?.idCertificato || undefined,
                  idImpedimento:
                    castedImpedimentoList.find(
                      (itemImpedimento) =>
                        itemImpedimento.sezione === currentEnteDichiaranteCodSezione
                    )?.key?.idImpedimento || undefined,
                  // Aggiornamento dell'id atto collegato se necessario
                  idAttoCollegato:
                    currentIdAttoCollegato ||
                    (formContext.values[itemKeyCurrentForm] as SectionVM)?.idAttoCollegato,
                  // Aggiornamento dell'id luogo se necessario
                  idLuogo: isCurrentUltimoLuogo ? dataSaved?.luogo?.key?.idLuogo : undefined,
                  idCertificatoUnioneCivile: isCurrentCertUnioneCivile
                    ? dataSaved?.certificatoUnioneCivileList?.find(
                        (itemCert) => itemCert.codiceSezione === itemKeyCurrent
                      )?.key?.idCertificatoUnioneCivile || undefined
                    : undefined,
                  idRegimePatrimoniale: isCurrentRegimePatrimoniale
                    ? castedRegimePatrimoniale.key?.idRegimePatrimoniale ||
                      (formContext.values[itemKeyCurrentForm] as SectionVM).idRegimePatrimoniale
                    : null,
                  idPubblicazione: isCurrentPubblicazione1
                    ? castedPubblicazioneList.find(
                        (item) => item.codiceSezione === CodeSection.PUBBLICAZIONE_1
                      )?.key?.idPubblicazione
                    : isCurrentPubblicazione2
                    ? castedPubblicazioneList.find(
                        (item) => item.codiceSezione === CodeSection.PUBBLICAZIONE_2
                      )?.key?.idPubblicazione
                    : undefined,
                  number: isCurrentDatiregistroEmergenza
                    ? castedStatoCivile?.numeroAttoRdE ||
                      (formContext.values[itemKeyCurrentForm] as SectionVM).number
                    : undefined,
                  identifier: isCurrentDatiregistroEmergenza
                    ? castedEvento?.idAttoCartaceo
                    : undefined,
                  // Impostazione dello stato isSaved su true
                  isSaved: true,
                } as SectionVM,
              }
            : {};

        // Aggiornamento dello stato dei valori del form con i nuovi valori costruiti
        newValues = {
          ...newValues,
          ...newValuesToDatiGeneraliRiconoscimento,
          ...newValuesToAutorizzioneRiconoscimento,
          ...newValuesCurrent,
        };
      });

      if (dataSaved?.datiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento) {
        // Aggiornamento dell'id dell'evento di riconoscimento se presente

        const keyChangeIdDatiEventoRiconoscimento = keyIdDatiEventoRiconoscimento.filter(
          (itemKey) => Boolean(newValues[itemKey])
        );

        keyChangeIdDatiEventoRiconoscimento.forEach((itemKeyIdDatiEventoRiconoscimento) => {
          if (itemKeyIdDatiEventoRiconoscimento.includes('subject')) {
            // se soggetto
            newValues[itemKeyIdDatiEventoRiconoscimento] = {
              ...((newValues[itemKeyIdDatiEventoRiconoscimento] as ParentVM) || {}),
              isSaved: true,
              generality: {
                ...((newValues[itemKeyIdDatiEventoRiconoscimento] as ParentVM) || {}).generality,
                idDatiEventoRiconoscimento:
                  dataSaved?.datiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento,
              },
            } as ParentVM;
          } else {
            // se sezione
            newValues[itemKeyIdDatiEventoRiconoscimento] = {
              ...((newValues[itemKeyIdDatiEventoRiconoscimento] as SectionVM) || {}),
              isSaved: true,
              idDatiEventoRiconoscimento:
                dataSaved?.datiEventoRiconoscimento?.key?.idDatiEventoRiconoscimento,
            } as SectionVM;
          }
        });
      }

      if (dataSaved?.consenso?.key?.idConsenso) {
        const keyChangeIdConsenso = keyIdConsenso.filter((itemKey) => Boolean(newValues[itemKey]));

        keyChangeIdConsenso.forEach((itemKeyIdConsenso) => {
          newValues[itemKeyIdConsenso] = {
            ...((newValues[itemKeyIdConsenso] as SectionVM) || {}),
            isSaved: true,
            idConsenso: dataSaved?.consenso?.key?.idConsenso,
          } as SectionVM;
        });
      }

      if (dataSaved?.riconoscimentoList?.length) {
        const keyChangeRiconoscimentoList = keyRiconoscimentoList.filter((itemKey) =>
          Boolean(newValues[itemKey])
        );

        keyChangeRiconoscimentoList.forEach((itemKeyRiconoscimentoList) => {
          newValues[itemKeyRiconoscimentoList] = {
            ...((newValues[itemKeyRiconoscimentoList] as SectionVM) || {}),
            isSaved: true,
            riconoscimentoList: dataSaved?.riconoscimentoList,
          } as SectionVM;
        });
      }

      if (
        configuration === ConfigurationType.REGPAT01 ||
        configuration === ConfigurationType.REGPAT02
      ) {
        const valuesAnn = (newValues[KeySections.keyAnnotazioneContestuale] as SectionVM) || {};
        const valuesRegimePatr = (newValues[KeySections.keyRegimePatrimoniale] as SectionVM) || {};

        const idAnnotazione = dataSaved?.datiAnnotazioneList?.find(
          (itemAnnotation) =>
            itemAnnotation.tipoAnnotazione === IdPropertyRegime.ConvenzioniMatrimoniali ||
            itemAnnotation.tipoAnnotazione === IdPropertyRegime.SeparazioneDeiBeni ||
            itemAnnotation.tipoAnnotazione === IdPropertyRegime.AltraLeggeApplicabile
        )?.key?.idDatiAnnotazione;

        newValues[KeySections.keyRegimePatrimoniale] = {
          ...valuesRegimePatr,
          annotationsPropertyRegime: {
            ...(valuesRegimePatr.annotationsPropertyRegime || {}),
            idAnnotazione,
          },
        } as SectionVM;

        const newArr = values.annotationsPropertyRegime?.textContextualAnnotation
          ? [
              {
                ...(values.annotationsPropertyRegime || {}),
                idAnnotazione,
                disabled: true,
              },
            ]
          : [];

        const arrCopy = valuesAnn.annotations?.slice() || [];

        newValues[KeySections.keyAnnotazioneContestuale] = {
          ...valuesAnn,
          annotations: arrCopy
            .filter(
              (itemAnnotation) =>
                itemAnnotation.typeContextualAnnotation !==
                  IdPropertyRegime.ConvenzioniMatrimoniali &&
                itemAnnotation.typeContextualAnnotation !== IdPropertyRegime.SeparazioneDeiBeni &&
                itemAnnotation.typeContextualAnnotation !== IdPropertyRegime.AltraLeggeApplicabile
            )
            .concat(newArr) as Array<Annotations>,
        } as SectionVM;
      }

      formContext.setValues({
        ...newValues,
      });
    });
  });

  const nothingRequired: boolean = useMemo(() => {
    if (configuration === ConfigurationType.ULT_LUOGO) {
      // sempre facoltativo
      return true;
    }

    if (
      presenza === typePresence.Facoltativo ||
      (presenza === typePresence.FacoltativoObbligatorio && !values.isRequiredFromOtherAccordion)
    ) {
      const valuesMomentary = { ...(values || {}), ...clearSectionMomentary() };

      return isObjectEmpty((valuesMomentary || {}) as Record<string, unknown>);
    }

    return false;
  }, [values, configuration, presenza]);

  const isComplib = useMemo(() => {
    return (
      configuration === ConfigurationType.COMPLIB01 || configuration === ConfigurationType.COMPLIB02
    );
  }, [configuration]);

  const isComplib3 = useMemo(() => {
    return configuration === ConfigurationType.COMPLIB03;
  }, [configuration]);

  const isTranscriptionDataTemplate = useMemo(() => {
    return (
      configuration === ConfigurationType.TRATXTBASE ||
      configuration === ConfigurationType.TRANEGASS ||
      configuration === ConfigurationType.TRATXTBASI ||
      configuration === ConfigurationType.TRATXTBASG ||
      configuration === ConfigurationType.TRATXTBASN ||
      configuration === ConfigurationType.TRATXBASRP ||
      configuration === ConfigurationType.TRATXTBASF ||
      configuration === ConfigurationType.TRATXTBASV ||
      configuration === ConfigurationType.TRATXTTISC ||
      configuration === ConfigurationType.TRATXBASF ||
      configuration === ConfigurationType.TRATXBASS ||
      configuration === ConfigurationType.TRATXBASQ ||
      configuration === ConfigurationType.TRATXTSCR ||
      configuration === ConfigurationType.TRASCRTISC ||
      configuration === ConfigurationType.TRATXTBASC ||
      configuration === ConfigurationType.TRASTXTRIC ||
      configuration === ConfigurationType.TRATXTUCE ||
      configuration === ConfigurationType.TRATXTUC2 ||
      configuration === ConfigurationType.TRATXTUC3 ||
      configuration === ConfigurationType.TRATXTMTE ||
      configuration === ConfigurationType.TRATXTMTAE ||
      configuration === ConfigurationType.TRATXBASR ||
      configuration === ConfigurationType.TRATXBASRN ||
      configuration === ConfigurationType.TRATXBASRQ ||
      configuration === ConfigurationType.TRATXBASRX ||
      configuration === ConfigurationType.TRATXBASRO ||
      configuration === ConfigurationType.TRATXTBSDE ||
      configuration === ConfigurationType.TRATXTBSDF ||
      configuration === ConfigurationType.TRATXBASC ||
      configuration === ConfigurationType.TRATXBASD ||
      configuration === ConfigurationType.ESIACSI2 ||
      configuration === ConfigurationType.DSCIT ||
      configuration === ConfigurationType.DSCITFR ||
      configuration === ConfigurationType.DSCIT3 ||
      configuration === ConfigurationType.DSCIT4 ||
      configuration === ConfigurationType.DSCIT10
    );
  }, [configuration]);

  const onUpdateText = useHttpClient('', {
    options: {
      method: 'GET',
      loading: true,
      errorCatching: true,
    },
  });

  // Aggiorna le variabili dei template
  const updateText = useEventCallback(() => {
    const url =
      isComplib || isComplib3
        ? `${__ACT_API_URL__}/valori-dominio-atti/dominio/102/idValoreAnsc/${idUseCase}/idEvento/${idEvento}`
        : isTranscriptionDataTemplate
        ? `${__ACT_API_URL__}/valori-dominio-atti/dominio/101/idValoreAnsc/${idUseCase}/idEvento/${idEvento}`
        : '';

    (
      onUpdateText({
        url,
      }) as ResponsePromise<HttpResponse<Array<ValoreDominioVO>>>
    ).then((responseUpdateText) => {
      const valueTemplate =
        (responseUpdateText?.data.payload || []).find(
          (item) =>
            item.key?.idValore?.toString() === values?.templateTranscription ||
            item.key?.idValore?.toString() === values?.templateTranscription2
        )?.valore || '';

      if (!valueTemplate) {
        return;
      }

      if (isComplib) {
        formContext.setValues({
          ...(formContext.values || {}),
          [keySection]: {
            ...(values || {}),
            actComposition: valueTemplate,
          },
          textAct: {
            ...(formContext.values?.textAct || {}),
            text: valueTemplate || '',
          },
        });
        return;
      }

      if (isTranscriptionDataTemplate) {
        onChange(
          values?.templateTranscription ? 'templateTranscriptionText' : 'summaryStatement',
          valueTemplate
        );
        return;
      }
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls={`panel-${keySection}-content`}
          id={`panel-${keySection}-header`}
          expandIcon={<ExpandMore />}
        >
          <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {title}
            &nbsp;
            {withErrors ? <Close color="error" /> : <Check color="success" />}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {open ? (
            <Grid item container spacing={2}>
              {configuration === ConfigurationType.BASEM ||
              configuration === ConfigurationType.BASEP ||
              configuration === ConfigurationType.SENPROCREP ||
              configuration === ConfigurationType.MORDATIAU ||
              configuration === ConfigurationType.ENTEDICHIF ||
              configuration === ConfigurationType.ENTEDICHIT ||
              configuration === ConfigurationType.ENTEDICHIN ||
              configuration === ConfigurationType.ENTEDICHA ||
              configuration === ConfigurationType.ENTEDICHNC ||
              configuration === ConfigurationType.PROVCOM ||
              configuration === ConfigurationType.CSAD ||
              configuration === ConfigurationType.CSRA ||
              configuration === ConfigurationType.DPSM ||
              configuration === ConfigurationType.TRDATIATAU ||
              configuration === ConfigurationType.TRDATIATIN ||
              configuration === ConfigurationType.RICATTCONS ||
              configuration === ConfigurationType.RICSECONS ||
              configuration === ConfigurationType.ENTEDICH ||
              configuration === ConfigurationType.ENTEDICHS ||
              configuration === ConfigurationType.ENTEDICHT ||
              configuration === ConfigurationType.ENTEDICHC ||
              configuration === ConfigurationType.ENTEDICHE ||
              configuration === ConfigurationType.IMPGEN ||
              configuration === ConfigurationType.IMPED01 ||
              configuration === ConfigurationType.IMPED02 ? (
                <ActConsent
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  nothingRequired={configuration === ConfigurationType.IMPED02 || nothingRequired}
                />
              ) : undefined}
              {configuration === ConfigurationType.TRASDATIAT ||
              configuration === ConfigurationType.TRAEDATIAT ? (
                <TranscriptionForeign
                  onChange={onChange}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.TRASDATIAU ||
              configuration === ConfigurationType.TRASDATIAF ||
              configuration === ConfigurationType.AUMITITA ||
              configuration === ConfigurationType.TRASDATIAV ||
              configuration === ConfigurationType.TRAEDATIAU ||
              configuration === ConfigurationType.ENTEDICHAC ? (
                <Authority
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  dateFormationAct={dateFormationAct}
                  nothingRequired={nothingRequired}
                />
              ) : undefined}
              {configuration === ConfigurationType.TRATXTBASE ||
              configuration === ConfigurationType.TRANEGASS ||
              configuration === ConfigurationType.TRATXTBASI ||
              configuration === ConfigurationType.TRATXTBASG ||
              configuration === ConfigurationType.TRATXTBASN ||
              configuration === ConfigurationType.TRATXBASRP ||
              configuration === ConfigurationType.TRATXTBASF ||
              configuration === ConfigurationType.TRATXTBASV ||
              configuration === ConfigurationType.TRATXTTISC ||
              configuration === ConfigurationType.TRATXBASF ||
              configuration === ConfigurationType.TRATXBASS ||
              configuration === ConfigurationType.TRATXBASC ||
              configuration === ConfigurationType.TRATXBASD ||
              configuration === ConfigurationType.TRATXBASQ ||
              configuration === ConfigurationType.TRATXTSCR ||
              configuration === ConfigurationType.TRASCRTISC ||
              configuration === ConfigurationType.TRATXTBASC ||
              configuration === ConfigurationType.TRASTXTRIC ||
              configuration === ConfigurationType.TRATXBASR ||
              configuration === ConfigurationType.TRATXBASRN ||
              configuration === ConfigurationType.TRATXBASRQ ||
              configuration === ConfigurationType.TRATXBASRX ||
              configuration === ConfigurationType.TRATXBASRO ||
              configuration === ConfigurationType.TRATXTUCE ||
              configuration === ConfigurationType.TRATXTUC2 ||
              configuration === ConfigurationType.TRATXTUC3 ||
              configuration === ConfigurationType.TRATXTMTE ||
              configuration === ConfigurationType.TRATXTMTAE ||
              configuration === ConfigurationType.TRASNASLU ||
              configuration === ConfigurationType.TRATXTBSDE ||
              configuration === ConfigurationType.TRATXTBSDF ? (
                <TranscriptionData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  tipoEvento={tipoEvento}
                  idUseCase={idUseCase}
                  idEvento={idEvento}
                  controllSentenceRecognitionNameSurname={controllSentenceRecognitionNameSurname}
                  controllApplicant={controllApplicant}
                  controllIsReceivedPrivateCitizen={controllIsReceivedPrivateCitizen}
                  controllTypeApplicant={controllTypeApplicant}
                  controllNumberHolders={controllNumberHolders}
                  controllNumberChildren={controllNumberChildren}
                />
              ) : undefined}
              {configuration === ConfigurationType.BASERIC ||
              configuration === ConfigurationType.BASERICNSE ? (
                <RecognitionBeforBirth
                  onChange={onChange}
                  values={values}
                  controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence={
                    controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence
                  }
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.BASERICAU ? (
                <RecognitionBeforBirthAct
                  onChange={onChange}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.BASEDECA ||
              configuration === ConfigurationType.BASEDECO ||
              configuration === ConfigurationType.BASEDECOV ||
              configuration === ConfigurationType.BASEDECNID ||
              configuration === ConfigurationType.DATIDECEST ||
              configuration === ConfigurationType.DATIDECGEN ? (
                <DeadData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  keySection={keySection}
                  setDataInterprete={setDataInterprete}
                  formContext={formContext}
                />
              ) : undefined}
              {configuration === ConfigurationType.BASECIT06 ||
              configuration === ConfigurationType.BASECIT07 ? (
                <CitizenshipBase
                  onChange={onChange}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  keySection={keySection}
                  setDataInterprete={setDataInterprete}
                />
              ) : undefined}
              {configuration === ConfigurationType.DSCIT ||
              configuration === ConfigurationType.DSCIT2 ||
              configuration === ConfigurationType.DSCIT3 ||
              configuration === ConfigurationType.DSCIT4 ||
              configuration === ConfigurationType.DSCIT6 ||
              configuration === ConfigurationType.DSCIT7 ||
              configuration === ConfigurationType.DSCIT8 ||
              configuration === ConfigurationType.DSCIT9 ||
              configuration === ConfigurationType.DSCIT10 ||
              configuration === ConfigurationType.DSCITFR ? (
                <CitizenshipCit
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  tipoEvento={tipoEvento}
                  idEvento={idEvento}
                  idUseCase={idUseCase}
                  controllSentenceRecognition={controllSentenceRecognition}
                />
              ) : undefined}
              {configuration === ConfigurationType.DPIMP ? (
                <CitizenshipDpImp
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                />
              ) : undefined}
              {configuration === ConfigurationType.ATCOBASE ||
              configuration === ConfigurationType.ATCOBASEN ||
              configuration === ConfigurationType.ATCOFA ||
              configuration === ConfigurationType.ATCOFAN ||
              configuration === ConfigurationType.ATCOBASECP ||
              configuration === ConfigurationType.ATCOBASED ||
              configuration === ConfigurationType.ATCOBASEDN ||
              configuration === ConfigurationType.ATCOBASEC ||
              configuration === ConfigurationType.RACTOD343 ||
              configuration === ConfigurationType.RACTOD344 ||
              configuration === ConfigurationType.RACTOD341 ||
              configuration === ConfigurationType.RACTOD441 ||
              configuration === ConfigurationType.RACTOD350 ||
              configuration === ConfigurationType.RACTOD0216 ||
              configuration === ConfigurationType.RACTOD0103 ||
              configuration === ConfigurationType.ATCODRM ||
              configuration === ConfigurationType.ATCODRMA ||
              configuration === ConfigurationType.ATCODRMM ||
              configuration === ConfigurationType.ATCODRMU ? (
                <ActRelated
                  onChange={onChange}
                  onChanges={onChanges}
                  onSave={onSave}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  nothingRequired={nothingRequired}
                  formContext={formContext}
                  onDelete={onDelete}
                  idEvento={idEvento}
                  idCat={tipoEvento}
                  isLastStepEmergency={isLastStepEmergency}
                />
              ) : undefined}
              {configuration === ConfigurationType.ASSRESO ? (
                <AssentSonDataNew
                  onChange={onChange}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                />
              ) : undefined}
              {configuration === ConfigurationType.COMPLIB01 ||
              configuration === ConfigurationType.COMPLIB02 ||
              configuration === ConfigurationType.COMPLIB03 ? (
                <ActComposition
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  idEvento={idEvento}
                  tipoEvento={tipoEvento}
                  idUseCase={idUseCase}
                  keySection={keySection}
                  formContext={formContext}
                />
              ) : undefined}
              {configuration === ConfigurationType.DGRECUP ||
              configuration === ConfigurationType.DGRECUP1 ||
              configuration === ConfigurationType.DGRECUP2 ? (
                <GeneralData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  tipoEvento={tipoEvento}
                />
              ) : undefined}
              {configuration === ConfigurationType.DTGANNMO ? (
                <GeneralDataGannmo
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  tipoEvento={tipoEvento}
                />
              ) : undefined}
              {configuration === ConfigurationType.RICDGCSAS ||
              configuration === ConfigurationType.RICDGAS ||
              configuration === ConfigurationType.RICDGP ||
              configuration === ConfigurationType.RICCONS ||
              configuration === ConfigurationType.RICASSE ||
              configuration === ConfigurationType.RICDGCS ||
              configuration === ConfigurationType.RICDGCSASC ||
              configuration === ConfigurationType.RICDGCSSE ||
              configuration === ConfigurationType.UCDTSP06 ? (
                <GeneralDataRecognition
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  setDataInterprete={setDataInterprete}
                  controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence={
                    controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence
                  }
                />
              ) : undefined}
              {configuration === ConfigurationType.DICHNNOCON ? (
                <GeneralDataLackConsent
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.GTRSCIT ||
              configuration === ConfigurationType.GTRSCIT2 ? (
                <ParentTransmittedCitizenship
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  tipoEvento={tipoEvento}
                  idEvento={idEvento}
                  idUseCase={idUseCase}
                  controllParentTransmittedCitizenship={controllParentTransmittedCitizenship}
                />
              ) : undefined}
              {configuration === ConfigurationType.RICGENIT ? (
                <ParentRecognition
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  controllParentRecognitionMadrePadreRiconoscimento={
                    controllParentRecognitionMadrePadreRiconoscimento
                  }
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.ESIACSI ||
              configuration === ConfigurationType.ESIACSI2 ? (
                <ResultVerificationMayor
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  idEvento={idEvento}
                  tipoEvento={tipoEvento}
                />
              ) : undefined}
              {configuration === ConfigurationType.GIURCIT ||
              configuration === ConfigurationType.GIURCIT2 ? (
                <GeneralDataOath
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.ULT_LUOGO ? (
                <LastPlace
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  nothingRequired={nothingRequired}
                />
              ) : undefined}
              {configuration === ConfigurationType.DSNAS01 ||
              configuration === ConfigurationType.DSNAS02 ||
              configuration === ConfigurationType.DSNAS03 ||
              configuration === ConfigurationType.DSNAS04 ||
              configuration === ConfigurationType.DSNAS05 ? (
                <GeneralDataBorn
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  controllIsPaternitySentence={controllIsPaternitySentence}
                  controllParentRecognitionMadrePadreRiconoscimento={
                    controllParentRecognitionMadrePadreRiconoscimento
                  }
                  controllParentChangedSurname={controllParentChangedSurname}
                  controllMeasureExchangeSurname={controllMeasureExchangeSurname}
                />
              ) : undefined}
              {configuration === ConfigurationType.UCDTSP ||
              configuration === ConfigurationType.UCDTSP02 ||
              configuration === ConfigurationType.UCDTSP03 ||
              configuration === ConfigurationType.UCDTSP04 ||
              configuration === ConfigurationType.UCDTSP05 ||
              configuration === ConfigurationType.MADTSP ||
              configuration === ConfigurationType.MADTSP2 ||
              configuration === ConfigurationType.MADTSP3 ||
              configuration === ConfigurationType.MADTSP4 ||
              configuration === ConfigurationType.MADTSP5 ||
              configuration === ConfigurationType.MADTSP6 ||
              configuration === ConfigurationType.MADTSP7 ||
              configuration === ConfigurationType.MADTSP8 ||
              configuration === ConfigurationType.MADTSP9 ? (
                <SpecificDataCivilUnionMarriage
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  controllOpposition={controllOpposition}
                  controllGenericImpediment={controllGenericImpediment}
                  controllImpedimentUnitedCivilly={controllImpedimentUnitedCivilly}
                  controllNumberWitnesses={controllNumberWitnesses}
                  setDataInterprete={setDataInterprete}
                  controllPublication={controllPublication}
                  controllMinorGroomAssistance={controllMinorGroomAssistance}
                  controllMinorWifeAssistance={controllMinorWifeAssistance}
                  controllAgeDefect={controllAgeDefect}
                  controllTemporaryBanRemarriage={controllTemporaryBanRemarriage}
                  controllRelationship={controllRelationship}
                  controllIsSonUnderFourteen={controllIsSonUnderFourteen}
                  controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence={
                    controllTypologyConsentTypeDeclarationParentRecognitionIsIncestuousSonSentence
                  }
                  formContext={formContext}
                  keySection={keySection}
                />
              ) : undefined}
              {configuration === ConfigurationType.CERTIF01 ? (
                <IncorporationCertificate
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  nothingRequired={nothingRequired}
                />
              ) : undefined}
              {configuration === ConfigurationType.REGPAT01 ||
              configuration === ConfigurationType.REGPAT02 ? (
                <PropertyRegime
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  controllPropertyRegime={controllPropertyRegime}
                  formContext={formContext}
                />
              ) : undefined}
              {configuration === ConfigurationType.COMSCIO ? (
                <ComsciousData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.PUBBLI ||
              configuration === ConfigurationType.PUBBLIDUE ? (
                <PubbliData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.SEPAR01 ||
              configuration === ConfigurationType.SEPAR02 ||
              configuration === ConfigurationType.SEPAR03 ||
              configuration === ConfigurationType.SEPAR04 ||
              configuration === ConfigurationType.SEPAR08 ||
              configuration === ConfigurationType.UCDTSU01 ||
              configuration === ConfigurationType.UCDTSU02 ||
              configuration === ConfigurationType.UCDTSU03 ? (
                <SeparationData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  formContext={formContext}
                  controllLawyerHusbandWife={controllLawyerHusbandWife}
                  controllTypeSeparation={controllTypeSeparation}
                  controllIsLawyerHusbandWife={controllIsLawyerHusbandWife}
                  setDataInterprete={setDataInterprete}
                />
              ) : undefined}
              {configuration === ConfigurationType.RICONC ? (
                <ReconciliationData
                  onChange={onChange}
                  onChanges={onChanges}
                  controllTypeSeparation={controllTypeSeparation}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.BASEUCST ||
              configuration === ConfigurationType.TRATXTUCSI ? (
                <BaseCivilUnionData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.NEGOZ1 ||
              configuration === ConfigurationType.NEGOZ2 ? (
                <NegotiationData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  controllLawyerHusbandWife={controllLawyerHusbandWife}
                />
              ) : undefined}
              {configuration === ConfigurationType.INTEGRAZ01 ? (
                <SupplementaryData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  nothingRequired={nothingRequired}
                />
              ) : undefined}
              {configuration === ConfigurationType.ASSFIG ? (
                <AssentSonData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  nothingRequired={nothingRequired}
                />
              ) : undefined}
              {configuration === ConfigurationType.BASEMTST ? (
                <MarriageData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  nothingRequired={nothingRequired}
                />
              ) : undefined}
              {configuration === ConfigurationType.FONTEPUBBL ? (
                <PublicationData
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  formContext={formContext}
                  idEvento={idEvento}
                />
              ) : undefined}
              {configuration === ConfigurationType.RICPOST ? (
                <ReceivedByPost
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  controllIsReceivedByPost={controllIsReceivedByPost}
                  formContext={formContext}
                  keySection={keySection}
                />
              ) : undefined}
              {configuration === ConfigurationType.CITLEG ? (
                <RefCitizenship
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  idUseCase={idUseCase}
                />
              ) : undefined}
              {configuration === ConfigurationType.FGIGN ? (
                <SonUnknownParents
                  onChange={onChange}
                  onChanges={onChanges}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                />
              ) : undefined}
              {configuration === ConfigurationType.ANNCONT ||
              configuration === ConfigurationType.ANNCONT105 ||
              configuration === ConfigurationType.ANNCONT312 ? (
                <AnnotationsData
                  onChange={onChange}
                  onChanges={onChanges}
                  onSave={onSaveSection}
                  values={values}
                  disabled={disabled}
                  errors={formContext.errors[keySection] as unknown as FormikErrors<SectionVM>}
                  touched={formContext.touched[keySection] as unknown as FormikTouched<SectionVM>}
                  configuration={configuration}
                  tipoEvento={tipoEvento}
                  idEvento={idEvento}
                  formContext={formContext}
                />
              ) : undefined}
              {configuration === ConfigurationType.ANNCONT ||
              configuration === ConfigurationType.ANNCONT105 ||
              configuration === ConfigurationType.ANNCONT312 ||
              configuration === ConfigurationType.FONTEPUBBL ||
              configuration === ConfigurationType.RACTOD343 ||
              configuration === ConfigurationType.RACTOD344 ||
              configuration === ConfigurationType.RACTOD341 ||
              configuration === ConfigurationType.RACTOD441 ||
              configuration === ConfigurationType.RACTOD0216 ||
              configuration === ConfigurationType.RACTOD0103 ||
              configuration === ConfigurationType.ATCODRMA ||
              configuration === ConfigurationType.ATCODRMM ||
              configuration === ConfigurationType.ATCODRMU ||
              configuration === ConfigurationType.RACTOD350 ? undefined : (
                <Grid item xs={12} display="flex" justifyContent="center">
                  <PmiButton
                    color="cdmBrand"
                    variant="outlined"
                    onClick={onDelete}
                    disabled={disabled}
                  >
                    Pulisci
                  </PmiButton>
                  <PmiButton
                    color="cdmBrandThird"
                    variant="outlined"
                    onClick={onSave}
                    disabled={disabled}
                    style={{ marginLeft: '1rem' }}
                  >
                    Salva
                  </PmiButton>
                  {isComplib || isComplib3 || isTranscriptionDataTemplate ? (
                    <Tooltip
                      arrow
                      title={
                        !values?.templateTranscription
                          ? 'Per aggiornare il testo è necessario selezionare un template'
                          : ''
                      }
                    >
                      <span style={{ height: 'fit-content' }}>
                        <PmiButton
                          color="cdmBrandThird"
                          variant="outlined"
                          onClick={updateText}
                          disabled={
                            disabled ||
                            (!values?.templateTranscription && !values?.templateTranscription2)
                          }
                          style={{ marginLeft: '1rem' }}
                        >
                          Aggiorna testo
                        </PmiButton>
                      </span>
                    </Tooltip>
                  ) : undefined}
                </Grid>
              )}
            </Grid>
          ) : undefined}
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

SectionComponent.displayName = 'Accordion Section component';

const Section = memo(SectionComponent);

export default Section;
